/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style.js'
import React from 'react'
import NavTabs from './nav-tabs.js'
import { ChartTable } from '../../treasury-chart/index.js'
import { Context } from './context/context.js'
import { Positions } from './positions/positions.js'
import { OpenOrders } from './open-orders/open-orders.js'
import { useOrderTicket, } from '../use-order-ticket'

export const Snapshot = () => {

    const { snapshotView:view, cusip, } = useOrderTicket()

    return <React.Fragment>

    <div data-name="order-ticket-form"
        className="container vertical-offset-sm"
        css={sectionCss}
    >
        <div className="row vertical-offset-sm"></div>

        <div className="row">
        <div className="col-md-12 col-xs-12">
            <NavTabs />
        </div>
        </div>

        <div className="row">
        <div className="col-md-12 col-xs-12">
            {
            view==='snapshot' && !cusip ? <ChartTable />
            : view==='snapshot' && cusip ? <Context />
            : view==='positions' ? <Positions />
            : view==='open-orders' ? <OpenOrders />
            : null}
        </div>
        </div>

    </div>
    </React.Fragment>
}
